import React, { useState } from 'react';
import Picker from '@emoji-mart/react';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';

const EmojiPicker = ({ onSelectEmoji, currentEmoji }) => {
    // const [selectedEmoji, setSelectedEmoji] = useState(currentEmoji);
    const [showPicker, setShowPicker] = useState(false);

    const handleEmojiSelect = (emoji) => {
        //setSelectedEmoji(emoji.native);
        setShowPicker(false); // Hide the picker after selection
        onSelectEmoji(emoji.native); // Notify the parent component
    };

    return (
        <Box position="relative" width="100%">
            <Button
                variant="contained"
                color="primary"
                onClick={() => setShowPicker((prev) => !prev)}
                fullWidth
            >
                Selected emoji: {currentEmoji}
            </Button>
            {showPicker && (
                <Box
                    marginTop={1}
                    marginBottom={1}
                >
                    <Picker
                        data={require('@emoji-mart/data')} // Ensure you have emoji-mart data installed
                        onEmojiSelect={handleEmojiSelect}
                    />
                </Box>
            )}
        </Box>
    );
};

export default EmojiPicker;
